<div
  *ngIf="!isLoading; else loading"
  class="element noselect"
  [class.selectable]="selectable"
  [class.selected]="selected"
  [class.disabled]="disabled"
>

  <!-- Background preview -->
  <div class="preview" [ngStyle]="getImagePreview()"></div>

  <!-- Content -->
  <div class="content">

    <!-- Title and subtitle -->
    <div class="card-info" [class.full-title]="!canEdit && !canRemove">
      <div class="title">{{title}}</div>
      <div class="subtitle" *ngIf="subtitleHTML" [innerHTML]="subtitleHTML | HtmlSanitizer"></div>
    </div>

    <!-- Top actions -->
    <div class="actions">
      <button *ngIf="canEdit" mat-stroked-button color="primary" (click)="edit($event)"><mat-icon>edit</mat-icon></button>
      <button *ngIf="canRemove" mat-stroked-button color="primary" (click)="remove($event)"><mat-icon>close</mat-icon></button>
    </div>

    <!-- Bottom icon with action -->
    <div class="icons">
      <span *ngFor="let icon of bottomIcons" class="element-icon" [class.with-text]="bottomIconText" (click)="bottomIconClick($event)">
      <mat-icon>{{icon}}</mat-icon>
      <span *ngIf="bottomIconText">{{bottomIconText}}</span>
    </span>
    </div>

    <!-- Selectable overlay -->
    <span *ngIf="!disabled && selectable && !selected" class="select-label">{{ 'Select resource' | translate }}</span>
    <span *ngIf="!disabled && selectable && selected" class="select-label selected">{{ 'Selected' | translate }}</span>

  </div>

</div>

<ng-template #loading>
  <div class="gradient"></div>
</ng-template>
